import { render, staticRenderFns } from "./SimpleRepairPlanSummarySubPage.vue?vue&type=template&id=2f4b6e46&"
import script from "./SimpleRepairPlanSummarySubPage.vue?vue&type=script&lang=ts&"
export * from "./SimpleRepairPlanSummarySubPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports